import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

const translations = {
  sr: {
    // Navigation
    nav_home: "Početna",
    nav_shop: "Prodavnica",
    nav_about: "O nama",
    nav_recipes: "Recepti",
    nav_contact: "Kontakt",
    
    // Age Gate
    age_title: "Dobrodošli",
    age_subtitle: "Destilerija Kovačić",
    age_question: "Da li ste stariji od 18 godina?",
    age_yes: "Da, imam 18+",
    age_no: "Ne",
    age_notice: "Morate imati 18 godina da biste pristupili ovom sajtu.",
    
    // Hero
    hero_subtitle: "UMETNOST U BOCI",
    hero_title: "Destilerija Kovačić",
    hero_tagline: "Tri džina. Tri karaktera. Jedna priča.",
    hero_description: "Ručno pravljeni kraft džinovi nastali u malim serijama sa vrhunskim sastojcima iz srca Mokrina.",
    hero_cta: "Upoznajte kolekciju",
    
    // Products
    products_title: "Naša Kolekcija",
    products_subtitle: "ОРИЏИН KOLEKCIJA",
    add_to_cart: "Dodaj u korpu",
    view_product: "Pogledaj",
    price_currency: "RSD",
    abv: "Alkohol",
    aroma: "MIRIS",
    taste: "UKUS",
    serving: "SERVIRANJE",
    
    // Cart
    cart_title: "Vaša korpa",
    cart_empty: "Vaša korpa je prazna",
    cart_continue: "Nastavi kupovinu",
    cart_total: "Ukupno",
    cart_checkout: "Završi kupovinu",
    cart_remove: "Ukloni",
    
    // Checkout
    checkout_title: "Završite porudžbinu",
    checkout_name: "Ime i prezime",
    checkout_email: "Email adresa",
    checkout_phone: "Telefon",
    checkout_address: "Adresa za dostavu",
    checkout_city: "Grad",
    checkout_postal: "Poštanski broj",
    checkout_notes: "Napomene (opciono)",
    checkout_submit: "Potvrdi porudžbinu",
    checkout_success: "Porudžbina uspešno poslata!",
    checkout_success_message: "Hvala vam na porudžbini. Kontaktiraćemo vas uskoro.",
    
    // About
    about_title: "O Nama",
    about_subtitle: "NAŠA PRIČA",
    about_story: "Destilerija Kovačić priča je o porodičnoj strasti i viziji, koju su 2021. godine pokrenuli dva brata — Miloš i Ivan Kovačić iz Mokrina.",
    about_dedication: "Njihova posvećenost kvalitetu i želja za stvaranjem jedinstvenih pića rezultirali su vrhunskim kraft džinovima koji osvajaju ljubitelje širom Srbije.",
    about_craft: "Svaka boca je rezultat pažljivo biranih biljaka i začina, sa ciljem da svaki gutljaj bude vrhunski doživljaj.",
    about_process: "Miloš i Ivan lično nadgledaju svaki korak proizvodnje, stavljajući autentičnost i kvalitet na prvo mesto.",
    about_welcome: "Dobrodošli u svet džinova Destilerije Kovačić — od 2021. godine, stvarano s ljubavlju za sve istinske ljubitelje džina.",
    
    // Recipes
    recipes_title: "Recepti za Koktele",
    recipes_subtitle: "UŽIVAJTE U SAVRŠENSTVU",
    recipes_ingredients: "Sastojci",
    recipes_instructions: "Priprema",
    
    // Contact
    contact_title: "Kontakt",
    contact_subtitle: "TU SMO ZA VAS",
    contact_name: "Vaše ime",
    contact_email: "Email adresa",
    contact_message: "Vaša poruka",
    contact_send: "Pošalji poruku",
    contact_success: "Poruka uspešno poslata!",
    contact_phone: "Telefon",
    contact_address: "Adresa",
    contact_location: "Mokrin, Srbija",
    
    // Footer
    footer_tagline: "Umetnost u boci od 2021.",
    footer_links: "Linkovi",
    footer_contact: "Kontakt",
    footer_follow: "Pratite nas",
    footer_rights: "Sva prava zadržana.",
    footer_age_notice: "Zabranjena prodaja alkoholnih pića osobama mlađim od 18 godina.",
    
    // Common
    loading: "Učitavanje...",
    error: "Greška",
    back: "Nazad",
    close: "Zatvori"
  },
  en: {
    // Navigation
    nav_home: "Home",
    nav_shop: "Shop",
    nav_about: "About",
    nav_recipes: "Recipes",
    nav_contact: "Contact",
    
    // Age Gate
    age_title: "Welcome",
    age_subtitle: "Destilerija Kovačić",
    age_question: "Are you over 18 years old?",
    age_yes: "Yes, I'm 18+",
    age_no: "No",
    age_notice: "You must be 18 years old to access this site.",
    
    // Hero
    hero_subtitle: "ART IN A BOTTLE",
    hero_title: "Destilerija Kovačić",
    hero_tagline: "Three gins. Three characters. One story.",
    hero_description: "Handcrafted gin made in small batches with premium ingredients from the heart of Mokrin.",
    hero_cta: "Discover the collection",
    
    // Products
    products_title: "Our Collection",
    products_subtitle: "ORIGIN COLLECTION",
    add_to_cart: "Add to cart",
    view_product: "View",
    price_currency: "RSD",
    abv: "ABV",
    aroma: "AROMA",
    taste: "TASTE",
    serving: "SERVING",
    
    // Cart
    cart_title: "Your Cart",
    cart_empty: "Your cart is empty",
    cart_continue: "Continue shopping",
    cart_total: "Total",
    cart_checkout: "Checkout",
    cart_remove: "Remove",
    
    // Checkout
    checkout_title: "Complete your order",
    checkout_name: "Full name",
    checkout_email: "Email address",
    checkout_phone: "Phone",
    checkout_address: "Delivery address",
    checkout_city: "City",
    checkout_postal: "Postal code",
    checkout_notes: "Notes (optional)",
    checkout_submit: "Confirm order",
    checkout_success: "Order successfully placed!",
    checkout_success_message: "Thank you for your order. We will contact you shortly.",
    
    // About
    about_title: "About Us",
    about_subtitle: "OUR STORY",
    about_story: "Destilerija Kovačić is a story of family passion and vision, started in 2021 by two brothers — Miloš and Ivan Kovačić from Mokrin.",
    about_dedication: "Their dedication to quality and desire to create unique spirits resulted in premium craft gins that are winning over enthusiasts across Serbia.",
    about_craft: "Every bottle is the result of carefully selected botanicals and spices, with the goal that every sip is a premium experience.",
    about_process: "Miloš and Ivan personally oversee every step of production, putting authenticity and quality first.",
    about_welcome: "Welcome to the world of Destilerija Kovačić gins — since 2021, created with love for all true gin lovers.",
    
    // Recipes
    recipes_title: "Cocktail Recipes",
    recipes_subtitle: "ENJOY PERFECTION",
    recipes_ingredients: "Ingredients",
    recipes_instructions: "Instructions",
    
    // Contact
    contact_title: "Contact",
    contact_subtitle: "WE'RE HERE FOR YOU",
    contact_name: "Your name",
    contact_email: "Email address",
    contact_message: "Your message",
    contact_send: "Send message",
    contact_success: "Message sent successfully!",
    contact_phone: "Phone",
    contact_address: "Address",
    contact_location: "Mokrin, Serbia",
    
    // Footer
    footer_tagline: "Art in a bottle since 2021.",
    footer_links: "Links",
    footer_contact: "Contact",
    footer_follow: "Follow us",
    footer_rights: "All rights reserved.",
    footer_age_notice: "Sale of alcoholic beverages to persons under 18 is prohibited.",
    
    // Common
    loading: "Loading...",
    error: "Error",
    back: "Back",
    close: "Close"
  }
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved || 'sr';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const t = (key) => {
    return translations[language][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'sr' ? 'en' : 'sr');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
